import EconomicCalendarV2Table from "@/ui-components/economic-calendar-v2-table";
import { CommonWidgetProps } from "../types";

function EconomicCalendarV2({ widgetCompositeId }: CommonWidgetProps) {
  return (
    <EconomicCalendarV2Table
      bodyRowClassNames="text-xs font-medium text-gray-900 dark:text-gray-100"
      widgetCompositeId={widgetCompositeId}
    />
  );
}

export default EconomicCalendarV2;
